export default "__VITE_ASSET__CAXViN_P__"